import type { IWeek } from '../shared/interfaces/IWeek';
import { NhlTeam } from './models/team';

type BracketPlayoffTeams = Record<string, Record<string, any[]>>;

declare const isDebugMode: boolean;

export class BracketGenerator {
  static playoffTeams: BracketPlayoffTeams = {
    '4': {},
    '3': {},
    '2': {},
    '1': {},
    '0': {},
  };
  static nameLength: number;
  static bracketHeight = 50;
  static iterations = 4;
  static skip = -1;
  static useByeWeek = false;
  static forkCount = 0;
  static debugMode = false;
  static bracketScale = 1.5;

  static GenerateBracket(
    rd1: IWeek[],
    rd2: IWeek[],
    confFinals: IWeek[],
    finals: IWeek[]
  ): void {
    const bracketsEl = document.getElementById('brackets');
    if (bracketsEl) bracketsEl.innerHTML = '';
    try {
      if (bracketsEl) bracketsEl.innerHTML = '';
      if (
        rd1[0].Series().length === 4 &&
        rd1[2].Series().length === 4 &&
        rd2[0].Series().length === 2 &&
        rd2[2].Series().length === 2 &&
        confFinals[0].Series().length === 1 &&
        confFinals[0].Series()[0].seriesDecided() &&
        confFinals[2].Series().length === 1 &&
        confFinals[2].Series()[0].seriesDecided() &&
        finals[1].Series().length === 1 &&
        finals[1].Series()[0].seriesDecided()
      ) {
        BracketGenerator.forkCount = 0;

        BracketGenerator.playoffTeams['1']['3'] = [
          rd1[0].Series()[0].games()[0]().home(),
          rd1[0].Series()[0].games()[0]().away(),
          isDebugMode ? '1-3' : rd1[0].Series()[0].getScoreFor(rd1[0].Series()[0].games()[0]().home),
          rd1[0].Series()[0].getScoreFor(rd1[0].Series()[0].games()[0]().away),
        ];

        BracketGenerator.playoffTeams['1']['10'] = [
          rd1[0].Series()[2].games()[0]().home(),
          rd1[0].Series()[2].games()[0]().away(),
          isDebugMode ? '1-10' : rd1[0].Series()[2].getScoreFor(rd1[0].Series()[2].games()[0]().home),
          rd1[0].Series()[2].getScoreFor(rd1[0].Series()[2].games()[0]().away),
        ];

        BracketGenerator.playoffTeams['1']['18'] = [
          rd1[0].Series()[1].games()[0]().home(),
          rd1[0].Series()[1].games()[0]().away(),
          isDebugMode ? '1-18' : rd1[0].Series()[1].getScoreFor(rd1[0].Series()[1].games()[0]().home),
          rd1[0].Series()[1].getScoreFor(rd1[0].Series()[1].games()[0]().away),
        ];

        BracketGenerator.playoffTeams['1']['25'] = [
          rd1[0].Series()[3].games()[0]().home(),
          rd1[0].Series()[3].games()[0]().away(),
          isDebugMode ? '1-25' : rd1[0].Series()[3].getScoreFor(rd1[0].Series()[3].games()[0]().home),
          rd1[0].Series()[3].getScoreFor(rd1[0].Series()[3].games()[0]().away),
        ];

        BracketGenerator.playoffTeams['1']['34'] = [
          rd1[2].Series()[0].games()[0]().home(),
          rd1[2].Series()[0].games()[0]().away(),
          isDebugMode ? '1-34' : rd1[2].Series()[0].getScoreFor(rd1[2].Series()[0].games()[0]().home),
          rd1[2].Series()[0].getScoreFor(rd1[2].Series()[0].games()[0]().away),
        ];

        BracketGenerator.playoffTeams['1']['41'] = [
          rd1[2].Series()[2].games()[0]().home(),
          rd1[2].Series()[2].games()[0]().away(),
          isDebugMode ? '1-49' : rd1[2].Series()[2].getScoreFor(rd1[2].Series()[2].games()[0]().home),
          rd1[2].Series()[2].getScoreFor(rd1[2].Series()[2].games()[0]().away),
        ];

        BracketGenerator.playoffTeams['1']['49'] = [
          rd1[2].Series()[1].games()[0]().home(),
          rd1[2].Series()[1].games()[0]().away(),
          isDebugMode ? '1-41' : rd1[2].Series()[1].getScoreFor(rd1[2].Series()[1].games()[0]().home),
          rd1[2].Series()[1].getScoreFor(rd1[2].Series()[1].games()[0]().away),
        ];

        BracketGenerator.playoffTeams['1']['56'] = [
          rd1[2].Series()[3].games()[0]().home(),
          rd1[2].Series()[3].games()[0]().away(),
          isDebugMode ? '1-56' : rd1[2].Series()[3].getScoreFor(rd1[2].Series()[3].games()[0]().home),
          rd1[2].Series()[3].getScoreFor(rd1[2].Series()[3].games()[0]().away),
        ];

        BracketGenerator.playoffTeams['2']['2'] = [
          rd1[0].Series()[0].seriesWinner()(),
          rd1[0].Series()[2].seriesWinner()(),
          isDebugMode ? '2-2' : rd2[0].Series()[0].getScoreFor(rd1[0].Series()[0].seriesWinner()),
          rd2[0].Series()[0].getScoreFor(rd1[0].Series()[2].seriesWinner()),
        ];

        BracketGenerator.playoffTeams['2']['17'] = [
          rd1[0].Series()[1].seriesWinner()(),
          rd1[0].Series()[3].seriesWinner()(),
          isDebugMode ? '2-17' : rd2[0].Series()[1].getScoreFor(rd1[0].Series()[1].seriesWinner()),
          rd2[0].Series()[1].getScoreFor(rd1[0].Series()[3].seriesWinner()),
        ];

        BracketGenerator.playoffTeams['2']['33'] = [
          rd1[2].Series()[0].seriesWinner()(),
          rd1[2].Series()[2].seriesWinner()(),
          isDebugMode ? '2-33' : rd2[2].Series()[0].getScoreFor(rd1[2].Series()[0].seriesWinner()),
          rd2[2].Series()[0].getScoreFor(rd1[2].Series()[2].seriesWinner()),
        ];

        BracketGenerator.playoffTeams['2']['48'] = [
          rd1[2].Series()[1].seriesWinner()(),
          rd1[2].Series()[3].seriesWinner()(),
          isDebugMode ? '2-48' : rd2[2].Series()[1].getScoreFor(rd1[2].Series()[1].seriesWinner()),
          rd2[2].Series()[1].getScoreFor(rd1[2].Series()[3].seriesWinner()),
        ];

        BracketGenerator.playoffTeams['3']['1'] = [
          rd2[0].Series()[0].seriesWinner()(),
          rd2[0].Series()[1].seriesWinner()(),
          isDebugMode ? '3-1' : confFinals[0].Series()[0].getScoreFor(rd2[0].Series()[0].seriesWinner()),
          confFinals[0].Series()[0].getScoreFor(rd2[0].Series()[1].seriesWinner()),
        ];

        BracketGenerator.playoffTeams['3']['32'] = [
          rd2[2].Series()[0].seriesWinner()(),
          rd2[2].Series()[1].seriesWinner()(),
          isDebugMode ? '3-32' : confFinals[2].Series()[0].getScoreFor(rd2[2].Series()[0].seriesWinner()),
          confFinals[2].Series()[0].getScoreFor(rd2[2].Series()[1].seriesWinner()),
        ];

        BracketGenerator.playoffTeams['4']['0'] = [
          confFinals[0].Series()[0].seriesWinner()(),
          confFinals[2].Series()[0].seriesWinner()(),
          isDebugMode ? '4-0' : finals[1].Series()[0].getScoreFor(confFinals[0].Series()[0].seriesWinner()),
          finals[1].Series()[0].getScoreFor(confFinals[2].Series()[0].seriesWinner()),
        ];

        BracketGenerator.playoffTeams['0']['0'] = [finals[1].Series()[0].seriesWinner()()];
        BracketGenerator.RenderBrackets();
      } else {
        if (bracketsEl) bracketsEl.innerHTML = '';
      }
    } catch (ex) {
      if (bracketsEl) bracketsEl.innerHTML = '';
    }
  }

  static RenderBrackets(): void {
    const brackets = document.getElementById('brackets');
    if (!brackets) return;
    brackets.innerHTML = '';
    const parentWidth = (brackets.parentElement as HTMLElement).offsetWidth;
    brackets.style.width = parentWidth + 'px';

    const canvas: HTMLCanvasElement = document.createElement('canvas');
    canvas.width = parentWidth;
    canvas.height = 888;
    const ctx = canvas.getContext('2d');
    ctx.translate(0.5, 0.5);
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    BracketGenerator.nameLength = Math.floor(canvas.width / (BracketGenerator.iterations + 1));
    ctx.fillStyle = 'black';
    ctx.font = '14px helvetica ';
    ctx.strokeStyle = 'black';
    ctx.lineWidth = 1;
    const x = canvas.width;
    const y = canvas.height / 2 + 3;
    BracketGenerator.drawWinner(ctx, x, y);
    BracketGenerator.fork(ctx, x - BracketGenerator.nameLength, y, BracketGenerator.iterations, BracketGenerator.bracketHeight);
    BracketGenerator.waterMark(ctx, canvas.width, canvas.height);
    brackets.style.display = '';
    brackets.appendChild(canvas);
    const uploadLink = document.createElement('a');
    uploadLink.href = 'javascript:void(0)';
    uploadLink.id = 'bracketUpload';
    uploadLink.className = 'pull-right btn btn-primary';
    uploadLink.innerHTML = '<i class="fa fa-cloud-upload"></i> Upload Bracket';
    brackets.appendChild(uploadLink);
  }

  static drawWinner(ctx: CanvasRenderingContext2D, x: number, y: number): void {
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x - BracketGenerator.nameLength, y);
    BracketGenerator.writeTeam(ctx, x - BracketGenerator.nameLength, y - 5, 0, 0, 0);
    ctx.stroke();
    ctx.closePath();
  }

  static fork(ctx: CanvasRenderingContext2D, x: number, y: number, iteration: number, height: number): void {
    const localCount = BracketGenerator.forkCount;
    BracketGenerator.forkCount++;
    const topOffset = y - height * iteration;

    if (iteration === 1 && BracketGenerator.useByeWeek) {
      BracketGenerator.skip++;
    }

    if (
      (iteration === 1 && BracketGenerator.skip % 2 === 0 && BracketGenerator.useByeWeek) ||
      x < 0 ||
      topOffset < 0 ||
      iteration < 0
    ) {
      return;
    }

    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x, topOffset);
    ctx.lineTo(x - BracketGenerator.nameLength, topOffset);
    ctx.stroke();
    BracketGenerator.writeTeam(ctx, x - BracketGenerator.nameLength, topOffset - 5, iteration, localCount, 0);
    ctx.closePath();
    BracketGenerator.fork(ctx, x - BracketGenerator.nameLength, topOffset, iteration - 1, height / BracketGenerator.bracketScale);

    const bottomOffset = y + height * iteration;
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.lineTo(x, bottomOffset);
    ctx.lineTo(x - BracketGenerator.nameLength, bottomOffset);
    ctx.stroke();
    BracketGenerator.writeTeam(ctx, x - BracketGenerator.nameLength, bottomOffset + 22, iteration, localCount, 1);
    ctx.closePath();
    BracketGenerator.fork(ctx, x - BracketGenerator.nameLength, bottomOffset, iteration - 1, height / BracketGenerator.bracketScale);
  }

  static writeTeam(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    iteration: number,
    localCount: number,
    idx: number
  ): void {
    try {
      x += 5;
      const team = BracketGenerator.playoffTeams[iteration][localCount][idx] as NhlTeam;
      const originalFont = ctx.font;
      const teamWidth = ctx.measureText(team.TeamName).width;
      const rankWidth = ctx.measureText(team.PlayoffRank()).width;
      if (teamWidth + 80 < BracketGenerator.nameLength) {
        ctx.fillText(team.PlayoffRank(), x + 5, y - 5);
        ctx.fillText(team.TeamName, x + rankWidth + 32 + 5, y);
        const score = BracketGenerator.playoffTeams[iteration][localCount][idx + 2];
        if (score !== undefined) {
          ctx.fillText(String(score), x + rankWidth + teamWidth + 32 + 8 + 5, y);
        }
      } else {
        ctx.fillText(team.PlayoffRank(), x + 5, y - 5);
        const score = BracketGenerator.playoffTeams[iteration][localCount][idx + 2];
        if (score !== undefined) {
          ctx.fillText(String(score), x + rankWidth + 32 + 8 + 5, y);
        }
      }
      ctx.font = '10px helvetica';
      ctx.font = originalFont;
      const logo = new Image();
      logo.src = '/content/nhl/svg/' + team.TeamAbbreviation + '-light.svg';
      logo.width = 48;
      logo.height = 32;
      logo.onload = () => {
        ctx.drawImage(logo, x + rankWidth + 5, y - 25, logo.width, logo.height);
      };
    } catch (ex) {
      if (BracketGenerator.debugMode) {
        ctx.fillText(iteration + '-' + localCount, x, y);
      }
    }
  }

  static waterMark(ctx: CanvasRenderingContext2D, x: number, y: number): void {
    BracketGenerator.measureAndWrite(ctx, x, y - 26, 'Created by Playoff Predictors');
    BracketGenerator.measureAndWrite(ctx, x, y - 12, 'https://PlayoffPredictors.com/');
    const logo = new Image();
    logo.src = '/content/playoff-predictor-color-02.svg';
    logo.width = 48;
    logo.height = 48;
    logo.onload = () => {
      ctx.drawImage(
        logo,
        x - ctx.measureText('https://PlayoffPredictors.com/').width - 48,
        y - 48,
        logo.width,
        logo.height
      );
    };
  }

  static measureAndWrite(ctx: CanvasRenderingContext2D, x: number, y: number, text: string): void {
    const measurements = ctx.measureText(text);
    ctx.fillText(text, x - measurements.width, y);
  }
}
